import raf from 'raf';
import randomInteger from '../generate/randomInteger';

const interval = (min, max) => randomInteger(min, max) * 1000;
const schedule = (task, min, max) => setTimeout(() => raf(task), interval(min, max));

export default schedule;



// WEBPACK FOOTER //
// ./app/scripts/util/window/schedule.js